import React, { useState, useMemo } from "react";
import { useSelector } from "react-redux";
import { Modal, Form, Input, Icon, Alert } from "antd";

import Tree from "./tree";
import useSearchedAddresses from "../../../hooks/useSearchedAddresses";

import "./addresses-modal.scss";

const AddressesModal = ({ onOk, onCancel, form }) => {
	const [searchInputValue, setSearchInputValue] = useState("");
	const opened = useSelector(
		(store) => store.votingStore.addressesModal.opened
	);
	const previousValue = useMemo(() => {
		return form.getFieldValue('addresses');
	}, [opened]);

	const loading = useSelector((store) => store.votingStore.addresses.loading);

	const [addresses, showEntity] = useSearchedAddresses(searchInputValue);

	if (!opened) {
		return null;
	}
	return (
		<Modal
			title="Выберите адреса"
			visible={opened}
			onOk={onOk}
			onCancel={() => {
				form.setFieldsValue(
					previousValue?.reduce((acc, value, houseId) => {
						acc[`addresses[${houseId}]`] = value;
						return acc;
					}, {})
				);
				onCancel();
			}}
			className="modal"
		>
			<Form.Item>
				<Input
					disabled={loading}
					value={searchInputValue}
					onChange={(e) => setSearchInputValue(e.target.value)}
					placeholder="Поиск адреса"
					prefix={<Icon type="search" />}
				/>
			</Form.Item>

			<Tree
				addresses={addresses}
				showEntity={showEntity}
				loading={loading}
				form={form}
			/>
			{!addresses.length &&
				!addresses.regions?.length &&
				!addresses.houses?.length &&
				searchInputValue && (
					<Alert
						message="Адреса не найдены"
						description="Попробуйте изменить поиск"
						type="info"
						showIcon
					/>
				)}
		</Modal>
	);
};

export default AddressesModal;
